let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("aEpRh"), load("K6fhx"), load("6hlNE"), load("71JfN")]).then(() => parcelRequire('dsuKz'));